import { useCallback, useLayoutEffect, useRef,useState } from 'react'
import ResizeObserver from 'resize-observer-polyfill'


const getRectForRef = (refElement) => refElement && refElement.getBoundingClientRect()

const useResizeObserver = (): [Partial<DOMRectReadOnly>, React.Dispatch<any>] => {
  const [observerEntry, setObserverEntry] = useState<Partial<DOMRectReadOnly>>()
  const [node, setNode] = useState(null)
  const observerRef = useRef(null)

  const disconnect = useCallback(() => observerRef.current && observerRef.current.disconnect() , [])
  const observe = useCallback(() => {
    if (node) {
      observerRef.current = new ResizeObserver(() => setObserverEntry(getRectForRef(node)))
      observerRef.current.observe(node)
    }
  }, [node])

  useLayoutEffect(() => {
    observe()

    return () => disconnect()
  }, [disconnect, observe])

  return [observerEntry, setNode]
}

export default useResizeObserver
